export default {
  en: {
    TABLE_HEADER_COL_NAME: 'Name',
    TABLE_HEADER_COL_EMAIL: 'Email',
    TABLE_HEADER_COL_ROLE: 'Role',
    TABLE_HEADER_COL_INVITATION: 'Invitation',
    TABLE_HEADER_COL_CAN_EXPORT: 'Can Export Reports',
    TABLE_HEADER_COL_URL_PARAMETER: 'URL Parameter',
    TABLE_HEADER_COL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    TABLE_HEADER_COL_REPORT_NAME: 'Report Name',

    WEBHOOKS_NAME: 'Name',
    WEBHOOKS_CALL_ID: 'Call Token',
    WEBHOOKS_REVENUE: 'Revenue Token',
    WEBHOOKS_FIRE_PIXEL: 'Fire Conversion',

    LAST_USE: 'Last Used',

    PING_TREES_MIN_REVENUE_TO_ROUTE: 'Min Rev.',
    PING_TREES_NAME: 'Name',
    PING_TREES_REVENUE_DYNAMIC_TO_ROUTE: 'Dynamic Rev.',
    PING_TREES_REVENUE_ON_FAILURE: 'Rev. On Failure',
    PING_TREES_STATUS: 'Status',
    PING_TREES_TARGETS: 'Targets',

    PUBLISHERS_NAME: 'Name',
    PUBLISHERS_ID: 'ID',
    PUBLISHERS_PERMISSIONS_NUMBER: 'Create Numbers',
    PUBLISHERS_CREATE_NUMBERS: 'Create Numbers',
    PUBLISHERS_CURRENT_DAY: 'Day',
    PUBLISHERS_CURRENT_HOUR: 'Hour',
    PUBLISHERS_CURRENT_LIVE: 'Live',
    PUBLISHERS_CURRENT_MONTH: 'Month',
    PUBLISHERS_STATUS: 'Status',
    PUBLISHERS_TOTAL: 'Total',

    NUMBERS_NAME: 'Name',
    NUMBERS_NUMBER: 'Number',
    NUMBERS_FORMATTED: 'Formatted',
    NUMBERS_ALLOCATION_DT: 'Allocated',
    NUMBERS_CHARGE_DT: 'Renews',
    NUMBERS_LINK_CAMPAIGN: 'Campaign',
    NUMBERS_LINK_POOL: 'Number Pool',
    NUMBERS_LINK_PUBLISHER: 'Publisher',
    NUMBERS_COUNTRY: 'Country',

    NUMBER_POOLS_NAME: 'Name',
    NUMBER_POOLS_COUNTRY: 'Country',
    NUMBER_POOLS_LOCK: 'Closed Browser Delay',
    NUMBER_POOLS_MAX_LOCK: 'Browser Idle Limit',
    NUMBER_POOLS_POOL_SIZE: 'Pool Size',
    IMPRESSIONS_DAY: 'Impressions per Day',
    MISSES_DAY: 'Misses per Day',
    IMPRESSIONS_MONTH: 'Impressions per Month',
    MISSES_MONTH: 'Misses per Month',
    NUMBER_POOLS_NUMBERS_ALLOCATING: 'Allocating',
  }
};
